











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponseRobo} from '@/model/resource/ResponseRobo'
import {ResponseRoboCollection} from '@/model/collection/ResponseRoboCollection'
import {ListResponseRoboSchema} from '@/schema/resource/ResponseRobo/ListResponseRoboSchema'
import {CsvResponseRoboSchema} from '@/schema/resource/ResponseRobo/CsvResponseRoboSchema'

@Component
export default class ListResponseRoboView extends Mixins(MixinQueryRouter) {
  schema = new ListResponseRoboSchema()
  collection = new ResponseRoboCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponseRobo) {
    Helper.pushByName('editResponseRobo', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponseRoboCollection().clearFilters().addFilter(params)

    await csv.listCsvResponseRobo()
    new CsvResponseRoboSchema().downloadCsv(csv.all())
  }
}
